import pathnames from "routes/pathnames";
import AppDashboardIcon from "components/icons/app-dashboard-icon";
import AppLeaveManagemetnIcon from "components/icons/app-leave-management-icon";
import AppClaimManagemetnIcon from "components/icons/app-claim-management-icon";
import AppCoachingIcon from "components/icons/app-coaching-icon";
import AppELearningIcon from "components/icons/app-e-learning-icon";
import AppOvertimeIcon from "components/icons/app-overtime-icon";

const sideNavList = [
	{
		label: "Dashboard",
		path: pathnames.dashboard,
		icon: AppDashboardIcon,
		childrens: [],
		relatives: [],
	},
	{
		label: "Leave Management",
		path: pathnames.leaves,
		icon: AppLeaveManagemetnIcon,
		relatives: [pathnames.leavesOverview],
		childrens: [
			{
				label: "Leave Calendar",
				path: pathnames.leaves,
				relatives: [],
			},
			{
				label: "Leave Summary",
				path: pathnames.leavesSummary,
				relatives: [],
			},
			{
				label: "Upcoming Leave",
				path: pathnames.leavesUpcoming,
				relatives: [],
			},
			{
				label: "Pending Approval",
				path: pathnames.leavesPending,
				relatives: [],
			},
			{
				label: "Leave History",
				path: pathnames.leavesHistory,
				relatives: [],
			},
			{
				label: "Team",
				path: null, 
				relatives: [pathnames.leavesOverview],
				childrens: [
					{
						label: "Pending Approval",
						path: pathnames.leaveRequests,
						relatives: [],
						childrens: [],
					},
					{
						label: "Leave Directory",
						path: pathnames.leavesDirectory,
						relatives: [pathnames.leavesOverview],
						childrens: [],
					},
				],
			}

		],
	},
	{
		label: "Allowance Management",
		path: pathnames.leaves,
		icon: AppClaimManagemetnIcon,
		relatives: [],
		childrens: [
			{
				label: "Allowance Summary",
				path: pathnames.claimSummary,
				relatives: [],
			},
			{
				label: "Allowance History",
				path: pathnames.claimHistory,
				relatives: [],
			},
			{
				label: "Pending Claim",
				path: pathnames.claimPending,
				relatives: [],
			},
		],
	},
	{
		label: "Overtime Management",
		path: pathnames.overtimePending,
		icon: AppOvertimeIcon,
		relatives: [],
		childrens: [
			{
				label: "Pending Approval",
				path: pathnames.overtimePending,
				relatives: [],
			},
			{
				label: "Overtime History",
				path: pathnames.overtimeHistory,
				relatives: [],
			},
			{
				label: "Team",
				path: null,
				relatives: [],
				childrens: [
					{
						label: "Pending Approval",
						path: pathnames.overtimeRequests,
						relatives: [],
						childrens: [],
					},
					{
						label: "Overtime History",
						path: pathnames.overtimeTeamHistory,
						relatives: [],
						childrens: [],
					},
				],
			},
		],
	},
	{
		label: "Appointment Management",
		path: pathnames.leaves,
		icon: AppCoachingIcon,
		relatives: [],
		childrens: [
			{
				label: "Appointment History",
				path: pathnames.pageAppointmentSession,
				relatives: [],
			},
			{
				label: "Upcoming",
				path: pathnames.pageUpcoming,
				relatives: [],
			},
		],
	},
	{
		label: "E-Learning",
		path: pathnames.ongoingAssigment,
		icon: AppELearningIcon,
		relatives: [],
		childrens: [
			{
				label: "Ongoing Assignment",
				path: pathnames.ongoingAssigment,
				relatives: [],
			},
			{
				label: "Certificate",
				path: pathnames.certificate,
				relatives: [],
			},
			{
				label: "Assignment History",
				path: pathnames.assignment,
				relatives: [],
			},
		],
	},
];
export default sideNavList;
